import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { DevicesApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class DevicesApiModule {
    public static forRoot(configurationFactory: () => DevicesApiConfiguration): ModuleWithProviders<DevicesApiModule> {
        return {
            ngModule: DevicesApiModule,
            providers: [ { provide: DevicesApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: DevicesApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('DevicesApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
